<template>
  <div class="main-register">
    <div class="title">ثبت نام</div>

    <custom-input type="email" placeholder="ایمیل" auth="auth" :emaillogo="true"  @getValue="setMail"/>
    <custom-input @showPassword="changeType" :type="type" placeholder="رمز عبور" auth="auth" :passwordlogo="true" @getValue="setPass"/>
    <custom-input type="password" placeholder="کد دعوت (اختیاری)" auth="auth" :passwordlogo="true" @getValue="setReferralCode"/>


    <label class="forget-pass">
      <a @click="check = !check" :class="{'check' : check === true}" class="submit">قوانین سایت</a><span> را مطالعه کرده و پذیرفته ام</span>
    </label>

    <div class="recaptcha">
<!--      <the-recaptcha/>-->
    </div>

    <label>
      <button :class="{'disable-Buttons':check === false}" :disabled='check === false'
              @click="registerUser" class="blue-btn">ثبت نام
      </button>
    </label>

    یا

    <div class="google" @click="googleSso">
      <img class="google-play" src="../../assets/icon/Google-log.png" alt="">
      <span>ورود از طریق گوگل </span>
    </div>

    <label class="link-div">
      <span>قبلا ثبت نام کرده اید؟</span> <a @click="$router.push('/auth/login')" class="link-to-signup"> وارد شوید </a>
    </label>

  </div>
</template>

<script>
import CustomInput from "../tools/custom-input";

export default {
  name: "the-Register",
  components: {CustomInput },
  data() {
    return {
      check: false,
      type: 'password'
      ,
      data:{
        email:'',
        password:'',
        osType: '',
        deviceType: '',
        browser: '',
        referralCode: "",
      },
    }
  },

  methods: {
    changeType() {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    async checkEmail() {
      if (!this.$validEmail(this.data.email) || !this.data.email) {
        this.emailError = 'ایمیل صحیح وارد نمایید'
        this.$error('اطلاعات وارد شده اشتباه است', 'ایمیل صحیح وارد نمایید')
        return Promise.reject('repeat failed : ' + this.data.email)
      } else {
        this.emailError = ''
      }
    },
    async checkPassword(){
      if (!this.$validPass(this.data.password) || this.data.password.length < 8) {
        this.passError = 'رمز باید حداقل 8 کاراکتر باشد و شامل حرف بزرگ ، حرف کوچک و عدد باشد'
        this.$error('اطلاعات وارد شده اشتباه است', 'رمز باید حداقل 8 کاراکتر باشد و شامل حرف بزرگ ، حرف کوچک و عدد باشد')
        return Promise.reject('wrong pass : ' + this.data.password)
      } else {
        this.passError = ''
      }
    },
    googleSso() {
      window.location.href = this.$axios.defaults.baseURL + '/users/google-sso'
    },
    async registerUser(){
      await this.checkEmail();
      await this.checkPassword()
      // this.state.loading=true;
      const res = await this.$axios.post('users/register', this.data)
      console.log(res)
      if(res.message === 'user created successfully , verification email sent'){
        if(res.baseDTO.towStepAuthenticationType ==='EMAIL'){
          this.$cookies.set('username', this.data.email)
          this.state.userInfo.email = this.data.email
          await this.$router.push('/sign-up/email-verification')
        }
      } else if (res.token) {
        this.$setToken(res.token, this.state.userInfo.remember)
        await this.$router.push('/login')
      }
      console.log('success')
    },
    async setMail(value) {
      this.data.email = value
    },
    async setPass(value) {
      this.data.password = value
    },
    async setReferralCode(value) {
      this.data.referralCode = value
    },
  },

  mounted() {
    //mount platform and etc.
    this.data.osType = this.$detectOs()
    this.data.browser = this.$detectBrowser() || 'CHROME'
    this.data.deviceType = this.$detectDevice()
    //save refferal in the localstorage
    if (this.$route.query.ref || localStorage.referralCode) {
      localStorage.referralCode = this.$route.query.ref || localStorage.referralCode
      this.data.referralCode = this.$route.query.ref || localStorage.referralCode
    }

  }
}
</script>

<style lang="scss" scoped>
.blue-btn {
  font-size: clamp(14px, 1.5vw, 16px);
  font-weight: bold;
}

.main-register {
  display: flex;
  flex-direction: column;
  gap: 20px;
  direction: rtl;
  color: #FBFBFD;

  label {
    position: relative;

    img {
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }


  button {
    width: 100%;
  }

  label {
    display: flex;
    align-items: center;
  }


  .google {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 0.75px solid #8C8585;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    color: rgba(140, 133, 133, 1);
    width: 100%;
    height: 36px;
    cursor: pointer;

    .google-play {
      width: 20px;
      height: 20px;
    }
  }

  .link-div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .link-to-signup {
    color: #1199FA;
    cursor: pointer;
    margin-right: 10px;
  }

  .recaptcha {
    display: flex;
    width: 100%;
    justify-content: start;
  }

  .forget-pass {
    .submit {
      color: #1199FA;
      font-size: clamp(10px, 2vw, 12px);
      margin: 0 20px 0 5px;
      position: relative;
      cursor: pointer;

      &:before {
        content: "";
        width: 12px;
        height: 12px;
        border: 1px solid #B2A7A7;
        box-sizing: border-box;
        border-radius: 3px;
        position: absolute;
        right: -20px;
        top: 1px;
      }
    }

    .check {
      color: #1199FA;
      font-size: clamp(10px, 2vw, 12px);
      margin: 0 20px 0 5px;
      position: relative;

      &:before {
        content: "";
        width: 12px;
        height: 12px;
        border: 1px solid #B2A7A7;
        box-sizing: border-box;
        border-radius: 3px;
        position: absolute;
        right: -20px;
        top: 1px;
        background-color: #1199FA;
      }
    }

    span {
      color: #FBFBFD;
      font-size: clamp(10px, 2vw, 12px);
    }

  }

  .title {
    font-size: clamp(16px, 2vw, 22px);
    color: #FBFBFD;
    font-weight: bold;
  }
}
</style>